import {MarkupNodeType, MarkupUnorderedListType} from '#src/constants.js';
import {createHtmlTag} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const LIST_TYPES = {
  c: MarkupUnorderedListType.Circle,
  d: MarkupUnorderedListType.Disc,
  s: MarkupUnorderedListType.Square
};

function convertUnorderedList({matchStart, options, text}) {
  let {type} = matchStart.groups;

  if (!type) {
    type = MarkupUnorderedListType.Disc;
  } else if (type.length === 1) {
    type = LIST_TYPES[type];
  }

  if (!type) {
    return '';
  }

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(MarkupNodeType.UnorderedList, {'data-type': type}, {isNonClosing: true});
  options.cl = '</div>';

  return text;
}

function convertOrderedList({matchStart, options, text}) {
  let {type} = matchStart.groups;

  if (!type) {
    type = '1';
  }

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(MarkupNodeType.OrderedList, {'data-type': type}, {isNonClosing: true});
  options.cl = '</div>';

  return text;
}

function convertListItem({matchStart, options, text}) {
  const {value} = matchStart.groups;

  options.skipType = SkipType.NoSkip;
  options.op = createHtmlTag(MarkupNodeType.ListItem, value ? {'data-value': value} : {}, {isNonClosing: true});
  options.cl = '</div>';

  return text;
}

export default [{
  cl: '[/ul]',
  convert: convertUnorderedList,
  nestable: true,
  op: /\[ul(?:\s+type="?(?<type>disc|circle|square|d|c|s)"?)?\s*\]/giu,
  priority: 4600
}, {
  cl: '[/ol]',
  convert: convertOrderedList,
  nestable: true,
  op: /\[ol(?:\s+type="?(?<type>[AaIi1])"?)?\s*\]/giu,
  priority: 4700
}, {
  cl: '[/li]',
  convert: convertListItem,
  nestable: true,
  op: /\[li(?:\s+value="?(?<value>\d+)"?\s*)?\]/giu,
  priority: 4800
}];
